import { render, staticRenderFns } from "./TheAside.vue?vue&type=template&id=11f34b63&"
import script from "./TheAside.vue?vue&type=script&lang=ts&"
export * from "./TheAside.vue?vue&type=script&lang=ts&"
import style0 from "./TheAside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports